export const baseUrl = '/location-preferences'
